import React from 'react';
import { getImageUrl } from '../../../../utils/imageUrl';
import './RefundMethod.css';

interface RefundMethodProps {
  totalRefundAmount: number;
  paymentMethod?: string;
  cardLastFour?: string;
  cardType?: string;
}

const RefundMethod: React.FC<RefundMethodProps> = ({ 
  totalRefundAmount, 
  paymentMethod,
  cardLastFour,
  cardType
}) => {
  const formatPrice = (price: number) => {
    return `₹${price.toLocaleString('en-IN')}`;
  };

  const getPaymentMethodDisplay = (method: string) => {
    switch (method) {
      case 'netbanking':
        return 'Net Banking';
      case 'upi':
        return 'UPI';
      case 'card':
        return 'Card';
      default:
        return method.toUpperCase();
    }
  };

  const getRefundMethodText = () => {
    if (cardLastFour) {
      return `Added to ${cardType || 'Card'} Ending in XXXX ${cardLastFour}`;
    }
    if (paymentMethod) {
      return `Added to ${getPaymentMethodDisplay(paymentMethod)}`;
    }
    return 'Refund method not specified';
  };

  return (
    <div className="refund-method-container">
      <h3 className="refund-method-title">Refund Method</h3>
      
      <div className="refund-amount-bar">
        <span className="refund-amount-label">Total Refund Amount</span>
        <span className="refund-amount-value">{formatPrice(totalRefundAmount)}</span>
      </div>
      
      <div className="refund-payment-info">
        <span className="refund-payment-text">{getRefundMethodText()}</span>
        {cardType && (
          <img 
            src={getImageUrl(`admin/static-assets/icons/payment/${cardType.toLowerCase()}.svg`)}
            alt={cardType}
            className="refund-card-icon"
            onError={(e) => {
              const target = e.target as HTMLImageElement;
              if (!target.dataset.errorHandled) {
                target.dataset.errorHandled = 'true';
                target.style.display = 'none';
              }
            }}
            loading="lazy"
          />
        )}
      </div>
    </div>
  );
};

export default RefundMethod;
